






















import { Vue, Component, Prop } from "vue-property-decorator";
import Modal from "@/components/form/Modal.vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

@Component({
  components: { Modal }
})
export default class TableActions extends Vue {
  /**
   * !!!
   * Компонент для действией даблицы.
   *
   * Действия @edit - Редактирование, и @remove - удалить
   *
   * Для отмены отображения одной из кнопок передаем Prop showEdit: false или showRemove: false соответственно
   *
   */
  @Prop({ default: true }) showEdit!: boolean;
  @Prop({ default: true }) showRemove!: boolean;
  @Prop({ default: false }) showLock?: boolean;
  @Prop({ default: i18n.tc(LocalesFields.Delete) }) removeTitle!: string;
}
